<!-- ? Proggress -->
<div class="w-full flex flex-wrap items-center">
  <!--? Progress Persent  -->
  <ng-container *ngIf="!challengeParticipants">
    <div class="w-full flex items-center justify-between">
      <!-- ? Pages -->
      <span
        class="text-gray-500 text-xs"
        [ngClass]="{
          'text-xs font-medium': textSize === size.XS
        }"
        *ngIf="totalCount"
      >
        {{ unitCount || 0 }} / {{ totalCount }}
      </span>

      <!-- ? Persent -->
      <span
        class="text-gray-500 text-xs"
        [ngClass]="{
          'text-xs font-medium': textSize === size.XS
        }"
        *ngIf="totalCount"
      >
        {{ (totalCount | progressWidth : unitCount || 0).textPersent }}
      </span>
    </div>
  </ng-container>

  <!-- ? Progress Bar -->
  <div
    class="relative rounded-xs bg-green-50 dark:bg-[#213028]"
    dir="rtl"
    *ngIf="totalCount"
    [ngClass]="{
      'w-full': !challengeParticipants,
      col: challengeParticipants,
      'h-1': textSize === size.XS,
      'h-2': textSize === size.SM,
      'h-3': textSize === size.MD,
      'h-4': textSize === size.LG
    }"
  >
    <div
      class="bar rounded-xs bg-green-500 dark:bg-green-400"
      *ngIf="totalCount"
      [ngClass]="{
        'h-1': textSize === size.XS,
        'h-2': textSize === size.SM,
        'h-3': textSize === size.MD,
        'h-4': textSize === size.LG
      }"
      [ngStyle]="{
        width: (totalCount | progressWidth : unitCount || 0).stylePersent
      }"
    ></div>
  </div>

  <ng-container *ngIf="challengeParticipants">
    <p class="text-xs green-500 mr-2" dir="ltr">
      {{ (totalCount | progressWidth : unitCount || 0).textPersent }}
    </p>
  </ng-container>
</div>
